var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnabledUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5049_15113",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.499999 0.5L0.5 18.5L18.5 18.5L18.5 0.499999L0.499999 0.5Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5049_15113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/exit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M17.1166 9.74714L17.1166 13.6903C17.1036 14.4472 16.7911 15.1681 16.2474 15.6949C15.7037 16.2216 14.9733 16.5112 14.2163 16.5002L4.40022 16.5002C3.64329 16.5112 2.91288 16.2216 2.36919 15.6949C1.8255 15.1681 1.51292 14.4472 1.5 13.6903L1.5 9.683C1.50191 9.56643 1.54994 9.45537 1.63357 9.37415C1.7172 9.29292 1.82961 9.24815 1.94619 9.24964C2.06272 9.2483 2.17505 9.29311 2.25865 9.37431C2.34224 9.4555 2.39032 9.56648 2.39237 9.683L2.39237 13.6903C2.40118 14.2142 2.61759 14.7132 2.99407 15.0777C3.37055 15.4421 3.8763 15.6422 4.40022 15.634L14.2163 15.634C14.7403 15.6422 15.246 15.4421 15.6225 15.0777C15.999 14.7132 16.2154 14.2142 16.2242 13.6903L16.2242 9.74714C16.2242 9.6288 16.2712 9.51531 16.3549 9.43164C16.4385 9.34796 16.552 9.30095 16.6704 9.30095C16.7887 9.30095 16.9022 9.34796 16.9859 9.43164C17.0695 9.51531 17.1166 9.6288 17.1166 9.74714ZM12.6547 4.76434C12.6548 4.82384 12.643 4.88277 12.62 4.93766C12.5971 4.99254 12.5633 5.04227 12.5208 5.08392C12.4349 5.16836 12.3192 5.21568 12.1987 5.21568C12.0783 5.21568 11.9626 5.16836 11.8766 5.08392L9.76116 2.9835L9.76116 12.1448C9.76042 12.2646 9.71242 12.3792 9.6276 12.4637C9.54278 12.5482 9.42801 12.5958 9.30828 12.596C9.24856 12.5972 9.18922 12.5863 9.13379 12.5641C9.07835 12.5418 9.02794 12.5087 8.98555 12.4666C8.94316 12.4245 8.90965 12.3744 8.887 12.3191C8.86436 12.2638 8.85304 12.2046 8.85373 12.1448L8.85373 2.98405L6.73935 5.08392C6.65351 5.16833 6.53793 5.21563 6.41754 5.21563C6.29715 5.21563 6.18158 5.16833 6.09573 5.08392C6.05306 5.04235 6.01915 4.99266 5.996 4.93777C5.97284 4.88288 5.96091 4.82391 5.96091 4.76434C5.96091 4.70477 5.97284 4.6458 5.996 4.59091C6.01915 4.53603 6.05306 4.48633 6.09573 4.44476L8.98647 1.57522C9.02838 1.53245 9.07847 1.49856 9.13376 1.47557C9.18905 1.45257 9.2484 1.44094 9.30828 1.44136C9.4285 1.44264 9.54352 1.49065 9.62898 1.57522L12.5208 4.44532C12.5633 4.4869 12.5969 4.53654 12.6199 4.59133C12.6429 4.64611 12.6547 4.70493 12.6547 4.76434Z",
    fill: "#003DA5",
    stroke: "#003DA5",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnabledUpload);
export default __webpack_public_path__ + "static/media/enabled-upload.755c4601bb16a55cefd369af4f2bc271.svg";
export { ForwardRef as ReactComponent };